import { render, staticRenderFns } from "./header-menu-mobile.vue?vue&type=template&id=10dacd34&scoped=true&"
import script from "./header-menu-mobile.vue?vue&type=script&lang=js&"
export * from "./header-menu-mobile.vue?vue&type=script&lang=js&"
import style0 from "./header-menu-mobile.vue?vue&type=style&index=0&id=10dacd34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dacd34",
  null
  
)

export default component.exports